import { marked } from 'marked';

/** Section labels the email rendered uppercase; the feed matches it via CSS on this class. */
const LABEL_PATTERN = /<p>(What(?:’|'|&#39;)s new in 2\.0:|What we(?:’|'|&#39;)re cooking:)<\/p>/g;

/**
 * Post markdown → HTML, the same `marked` the legal pages use. The email
 * these posts came from uppercased its section labels with CSS only, so the
 * two label paragraphs get a class here and the text stays sentence case.
 */
export const renderMarkdown = (markdown: string): string =>
  (marked.parse(markdown, { async: false }) as string).replace(
    LABEL_PATTERN,
    (_match, label: string) => `<p class="label">${label}</p>`
  );
